module.exports = __webpack_public_path__ + "img/guaranteed-safe-checkout.0ef04d70.png";